// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CirclePlus = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M71.5 48a2 2 0 0 1-2 2H50v19a2 2 0 0 1-4 0V50H26.5a2 2 0 0 1 0-4H46V27a2 2 0 0 1 4 0v19h19.5a2 2 0 0 1 2 2M48 83.5c-19.575 0-35.5-15.925-35.5-35.5S28.425 12.5 48 12.5 83.5 28.425 83.5 48 67.575 83.5 48 83.5m0-75C26.22 8.5 8.5 26.22 8.5 48S26.22 87.5 48 87.5 87.5 69.78 87.5 48 69.78 8.5 48 8.5"
			fillRule="evenodd"
		/>
	</svg>
);
export default CirclePlus;
